import { EventEmitter, Injectable } from '@angular/core';
import { Table, TableField, TableFieldText, TableRow } from '@docpath/webcomponents/table';
import { CloudService } from 'src/app/shared/services/cloud.service';

import { Hour } from '../../models/hour';
import { HomeHttpService } from '../../services/home-http.service';

@Injectable({
    providedIn: 'root'
})

export class HomeTableService {
    hourLoaded: EventEmitter<Hour[]> = new EventEmitter();
    private hours: Hour[] = [];
    private readonly i18nPrefix = 'home';

    constructor(
        private readonly homeHttpService: HomeHttpService,
        private readonly cloudService: CloudService
    ) { }

    getHours(): Hour[] {
        return this.hours;
    }

    loadHour(loading: boolean): void {
        this.homeHttpService.getHour(loading, result => {
            this.hours = result as Hour[];
            this.hourLoaded.emit(result);
        });
    }

    refreshHour(): void {
        this.homeHttpService.refreshHour(result => {
            this.hours = result as Hour[];
            this.hourLoaded.emit(result);
        });
    }

    initTable(): Table {
        const header = this.initTableHeader();
        const body = this.initTableBody([]);
        return new Table(header, body);
    }

    initTableHeader(): TableRow {
        const style = 'text-align:center';

        return new TableRow(
            [
                new TableFieldText(`${this.i18nPrefix}.table.time`, undefined, undefined, undefined, undefined, true),
                new TableFieldText(
                    this.cloudService.isModeCloud() ? `${this.i18nPrefix}.table.generated-transactions` : `${this.i18nPrefix}.table.generated-documents`,
                    undefined, { style }, undefined, undefined, true),
                new TableFieldText(`${this.i18nPrefix}.table.received-jobs`, undefined, { style }, undefined, undefined, true),
                new TableFieldText(`${this.i18nPrefix}.table.successful-jobs`, undefined, { style }, undefined, undefined, true),
                new TableFieldText(`${this.i18nPrefix}.table.average-queue`, undefined, { style }, undefined, undefined, true),
                new TableFieldText(`${this.i18nPrefix}.table.errors`, undefined, { style }, undefined, undefined, true)
            ]
        );
    }

    initTableBody(hour: Hour[]): TableRow[] {
        const style = 'text-align:center';

        return hour.map(hour => {
            const fields: TableField[] = [];
            fields.push(new TableFieldText(hour.time, undefined, { style: 'font-weight: bold;' }));
            fields.push(new TableFieldText(
                this.cloudService.isModeCloud() ? hour.generatedTransactions.toString() : hour.generatedDocuments.toString(),
                undefined, { style }));
            fields.push(new TableFieldText(hour.receivedJobs.toString(), undefined, { style }));
            fields.push(new TableFieldText(hour.executedJobs.toString(), undefined, { style }));
            fields.push(new TableFieldText(`${hour.averageQueue.toString()} ms`, undefined, { style }));
            const customStylesErrors = hour.errors > 0 ? { cssClass: 'text-dpred text-center', style: 'font-weight: bold' } : { cssClass: 'text-center', style: 'font-weight: bold' };
            fields.push(new TableFieldText(hour.errors.toString(), undefined, customStylesErrors));
            const tableRow = new TableRow(fields);
            tableRow.content = hour;
            return tableRow;
        });
    }
}

